import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, Progress, TitleHeader } from 'web-library';
import { useGetExamLevelsAndResourceTypes } from '../../../api-refactored/onlineTutorials/useGetExamLevelsAndResourceTypes';
import UsefulInformationFilters from '../../../modules/usefulInformation/@candidate/components/UsefulInformationFilters';

const UsefulInformationListing = () => {
  const { t } = useTranslation();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const { data } = useGetExamLevelsAndResourceTypes({
    onSuccess: () => {
      setIsSuccess(true);
    },
  });

  return (
    <>
      <TitleHeader title={t('usefulInformation->>Listing.UsefulInformation')} />
      {isSuccess ? (
        <UsefulInformationFilters
          examAndResourceData={data || { examLevels: [], resourceTypes: [] }}
        />
      ) : (
        <ContentTemplate>
          <Progress color="secondary" />
        </ContentTemplate>
      )}
    </>
  );
};

export default UsefulInformationListing;
